/**
 * @file input.tsx
 * @description Input-примитив (phase08.5). Field с bottom-border акцентом
 * на focus (Academic Luminary стиль).
 */

import * as React from "react";

import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          "flex h-10 w-full rounded-md bg-input px-3 py-2 text-sm text-on-surface",
          "placeholder:text-on-surface-muted",
          "transition-all outline-none",
          "focus-visible:bg-surface-lowest focus-visible:[box-shadow:inset_0_-2px_0_var(--primary)]",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",
          "aria-invalid:[box-shadow:inset_0_-2px_0_var(--destructive)]",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";
